import CampaignIcon from '@mui/icons-material/Campaign';

import { CommunicationList } from '@/view/communication/CommunicationList';

export default {
  list: CommunicationList,
  icon: CampaignIcon,
};
